import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    updateGR_ItemAction,
    updateGR_ItemAccountAssignmentAction
} from '../../redux/actions/GRAction'
import {
    data_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
}from '../../configs/datas'

import {
    getPODetailOriginalAction,
} from '../../redux/actions/MainAction'
import {
    EVENT_GET_PO_GRITEM_ORIGINAL
} from '../../configs/EventTypes'

class AddItemModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
        }

        window.emitter.addListener(EVENT_GET_PO_GRITEM_ORIGINAL, this.getPOOriginal.bind(this))

    }

    copyItem(datas){
        console.log("copyItem");
        const _item_no = datas.item_no
        const { t_GR_ITEM, t_GR_ITEM_ACCOUNT_ASSIGNMENT, updateGR_Item,updateGR_ItemAccountAssignment, t_GR_SERVICE } = this.props
        let item_curent = t_GR_ITEM;
        let item_no_all = [];
        item_curent.forEach(element => {
            item_no_all.push(element.item_no)
        });

        //console.log(item_no_all);
        item_no_all.sort(function(a, b){return b-a});
        let item_no_next = Number(item_no_all[0])+1;

        let item_no_service = t_GR_SERVICE.filter((data) => {
            return data.service_item_no && data.service_item_no.toString() === item_no_next.toString()
        })
        if (item_no_service && item_no_service.length > 0) {

            let item_curent_service = t_GR_SERVICE;
            let item_no_all_service = [];
            item_curent_service.forEach(element => {
                item_no_all_service.push(element.service_item_no)
            });

            item_no_all_service.sort(function (a, b) { return b - a });
            item_no_next = Number(item_no_all_service[0]) + 1;
        }
        

        let item_new = datas;
        let contract_item_no = item_new.item_no;
        
        item_new.contract_item_no = contract_item_no;
        item_new.item_id = item_no_next;
        item_new.item_no = item_no_next;
        item_new.checked = 1;

        let objItem = t_GR_ITEM.find(s => s.checked)
        if (typeof (objItem) !== "undefined") {

            item_new.goods_recipient = objItem.goods_recipient
            item_new.requisitioner = objItem.requisitioner
            item_new.unloading_point = objItem.unloading_point
        }

        updateGR_Item(item_new);
        let _item = t_GR_ITEM_ACCOUNT_ASSIGNMENT.find(f=>f.item_no === _item_no)
        let itemAcc = {
            ..._item,
            item_no : item_no_next,
            acc_id: 1
        }
        updateGR_ItemAccountAssignment(itemAcc, "")

        // window.emitter.emit("loadGRItem_AddItemModal", {
        //     message: "Add GR Item"
        // })
    }

    getPOOriginal(object){
  
        if (object) {
            this.props.getPODetailOriginal(object.po_no, object.unitCode, object.userId);
        }
    }


    render() {
       
        const {po_original} = this.props;
        let t_GR_ITEM = po_original.t_GR_ITEM;
    
        return (
            <div className="modal fade sp-modal rrs-modal" id="AddItemModal" tabIndex={-1} role="dialog" aria-labelledby="AddItemModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="AddItemModalLabel">เพิ่มรายการรับสินค้า</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            <div className="rrs-detail3">
                             <div className="row no-gutters sp-table-content">
                                <div className="col-12">
                                    <table className="sp-table table rrs-table-2">
                                   
                                        <thead>
                                            <tr className="sp-table-header">
                                                <th className="sp-table-header" width="5%"><div className="th-text">A</div></th>
                                                <th className="th-table" width="5%"><div className="th-text">I</div></th>
                                                <th className="th-table"><div className="th-text">Material</div></th>
                                                <th className="th-table"><div className="th-text">Short Text</div></th>
                                                <th className="th-table"><div className="th-text">PO/Target Qty</div></th>
                                                {/* <th className="th-table"><div className="th-text">Remainning Qty</div></th> */}
                                                <th className="th-table" width="5%"><div className="th-text">Action</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                            t_GR_ITEM && t_GR_ITEM.map((datas, index) => (
                                                <tr key={index}>
                                                    <td>{datas.a}</td>
                                                    <td>{datas.i}</td>
                                                    <td>{datas.material}</td>
                                                    <td>{datas.short_text}</td>
                                                    <td>{datas.po_qty}</td>
                                                    {/* <td>{datas.remaining_qty}</td> */}
                                                    <td>
                                                        <button className="btn btn-info btn-choose-item" data-dismiss="modal" aria-label="Close" onClick={() => this.copyItem(datas)}>
                                                            เลือก
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        po_original: MainRedux.po_original,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
      updateGR_Item: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAction(data, index, fieldName)),
      updateGR_ItemAccountAssignment:(data, index, fieldName)=>dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName)),
      getPODetailOriginal: (poNo, unitCode, userId) => dispatch(getPODetailOriginalAction(poNo, unitCode, userId)),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddItemModal)